export const isNativeApp = (): boolean =>
  typeof navigator !== "undefined" &&
  /GroundediOS|despia/i.test(navigator.userAgent);
